import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ClientSignup from "@/pages/ClientSignup";
import PaymentStatus from "@/pages/PaymentStatus";
import PaymentCancel from "@/pages/PaymentCancel";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import Therapists from "@/pages/admin/Therapists";
import Plans from "@/pages/admin/Plans";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSettings from "@/pages/admin/Settings";
import AdminUsers from "@/pages/admin/Users";

import TherapistDashboard from "@/pages/therapist/TherapistDashboard";
import Clients from "@/pages/therapist/Clients";
import Exercises from "@/pages/therapist/Exercises";
import Agenda from "@/pages/therapist/Agenda";
import TherapistProfile from "@/pages/therapist/Profile";
import Values from "@/pages/therapist/Values";
import TherapistContent from "@/pages/therapist/TherapistContent";
import Payments from "@/pages/therapist/Payments";
import TherapistReviews from "@/pages/therapist/Reviews";

import ClientDashboard from "@/pages/client/ClientDashboard";
import Journey from "@/pages/client/Journey";
import MyExercises from "@/pages/client/MyExercises";
import Library from "@/pages/client/Library";
import Appointments from "@/pages/client/Appointments";
import ProfessionalProfile from "@/pages/client/ProfessionalProfile";
import TherapistDirectory from "@/pages/client/TherapistDirectory";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Register />} />
            <Route path="/cadastro-cliente" element={<ClientSignup />} />
            <Route path="/payment/success" element={<PaymentStatus />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            <Route element={<ProtectedRoute roles={["admin"]} />}>
              <Route path="/admin" element={<DashboardLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="hipnoterapeutas" element={<Therapists />} />
                <Route path="planos" element={<Plans />} />
                <Route path="conteudos" element={<AdminContent />} />
                <Route path="usuarios" element={<AdminUsers />} />
                <Route path="configuracoes" element={<AdminSettings />} />
              </Route>
            </Route>

            <Route element={<ProtectedRoute roles={["therapist"]} />}>
              <Route path="/painel" element={<DashboardLayout />}>
                <Route index element={<TherapistDashboard />} />
                <Route path="clientes" element={<Clients />} />
                <Route path="exercicios" element={<Exercises />} />
                <Route path="agenda" element={<Agenda />} />
                <Route path="pagamentos" element={<Payments />} />
                <Route path="conteudos" element={<TherapistContent />} />
                <Route path="perfil" element={<TherapistProfile />} />
                <Route path="valores" element={<Values />} />
                <Route path="avaliacoes" element={<TherapistReviews />} />
              </Route>
            </Route>

            <Route element={<ProtectedRoute roles={["client"]} />}>
              <Route path="/app" element={<DashboardLayout />}>
                <Route index element={<ClientDashboard />} />
                <Route path="jornada" element={<Journey />} />
                <Route path="exercicios" element={<MyExercises />} />
                <Route path="conteudos" element={<Library />} />
                <Route path="consultas" element={<Appointments />} />
                <Route path="profissional" element={<ProfessionalProfile />} />
                <Route path="encontrar" element={<TherapistDirectory />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
